module.exports = __webpack_public_path__ + "media/images/pro/5-0fa21f89b9eed940f2d694b9710e58e9.png";